export const MIN_COLUMN_WIDTH = 120;
